import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';

import useFetch from 'src/hooks/useFetch';

import Container from 'src/components/Layouts/Container';
import { Title } from 'src/components/Layouts/Container/styles';

import { PIX_ENABLED } from 'src/consts/common';

import CardPlano from './CardPlano';

export function ContratarAssinatura(props) {
  const { planoId } = props;

  const history = useHistory();
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [openChoosePayment, setOpenChoosePayment] = useState(false);

  const { isLoading, data } = useFetch(`/buscarPlanoAssinatura/${planoId}`);

  const goToCreditCard = (plano) => {
    history.push({
      pathname: '/PagamentoComCartao',
      state: {
        type: 'ASSINATURA',
        isOpeningCompany: false,
        plano,
      },
    });
  };

  const onCardPress = (plano) => {
    if (!PIX_ENABLED) {
      goToCreditCard(plano);
      return;
    }

    setSelectedPlan(plano);
    setOpenChoosePayment(true);
  };

  const handleChooseCreditCard = () => {
    if (!selectedPlan) return;

    goToCreditCard(selectedPlan);
  };

  const handleChoosePixAutomatico = () => {
    if (!selectedPlan) return;

    history.push({
      pathname: '/PagamentoComPixAutomatico',
      state: {
        signaturePlan: selectedPlan,
      },
    });
  };

  return (
    <Container isLoading={isLoading}>
      <Title>Planos de Assinatura</Title>
      <div>
        {data?.length > 0 &&
          data.map((planItem) => {
            return (
              <CardPlano
                key={planItem?.id}
                plan={planItem}
                planDescription={planItem.descricao}
                onClick={onCardPress}
              />
            );
          })}
      </div>
      <Dialog
        open={openChoosePayment}
        onClose={() => setOpenChoosePayment(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Escolha a forma de pagamento</DialogTitle>
        <DialogContent>
          <Typography>
            Selecione como deseja contratar a sua assinatura.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenChoosePayment(false)}>Cancelar</Button>
          <Button color="primary" onClick={handleChooseCreditCard}>
            Cartão de Crédito
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={handleChoosePixAutomatico}
          >
            Pix Recorrente
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

ContratarAssinatura.propTypes = {
  planoId: PropTypes.number.isRequired,
};
